import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Alert from '@mui/material/Alert';
import "./FeedbackForm.css";
import { FeedbackAPI } from "../../services/dbApi";
import { toast } from "react-toastify";

const starMap = [
  { label: 'Very Poor', color: '#d32f2f' },
  { label: 'Poor', color: '#f57c00' },
  { label: 'Average', color: '#fbc02d' },
  { label: 'Good', color: '#7cb342' },
  { label: 'Excellent', color: '#388e3c' }
];

const FeedbackForm = () => {
  const navigate = useNavigate();
  const [question1Rating, setQuestion1Rating] = useState(0);
  const [question2Rating, setQuestion2Rating] = useState(0);
  const [question3Rating, setQuestion3Rating] = useState(0);
  const [question4Rating, setQuestion4Rating] = useState(0);
  const [rating, setRating] = useState(0); // Used only for display
  const [message, setMessage] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [alertType, setAlertType] = useState(null);
  const [alertMessage, setAlertMessage] = useState('');

  useEffect(() => {
    const ratings = [question1Rating, question2Rating, question3Rating, question4Rating];

    const avg = ratings.reduce((a, b) => a + b, 0) / 4;
    setRating(avg);
  }, [question1Rating, question2Rating, question3Rating, question4Rating]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      question1Rating === 0 ||
      question2Rating === 0 ||
      question3Rating === 0 ||
      question4Rating === 0
    ) {
      setAlertType("error");
      toast.error("All ratings are mandatory", { toastId: "ratings-mandatory" });
      setTimeout(() => {
        setAlertType(null);
        setAlertMessage("");
      }, 2000);
      return;
    }

    const formData = {
      question1: question1Rating,
      question2: question2Rating,
      question3: question3Rating,
      question4: question4Rating,
      message,
    };


    // try {
    //   const response = await FeedbackAPI.submitFeedback(formData);
    //   const data = response.data;
    //       if (data.message === "Feedback submitted successfully") {
    //         setTimeout(() => {
    //           setShowSuccessPopup(true);
    //           setAlertType("success");
    //           setSubmitted(true);
    //           setAlertMessage('');
    //           window.location.reload();
    //         }, 500);
    //       } else {
    //         setTimeout(() => {
    //           setAlertType("error");
    //           setAlertMessage(data.message || "Submission failed.");
    //         });
    //       }
    // } catch (err) {
    //       setTimeout(() => {
    //         setAlertType("error");
    //         setAlertMessage("Feedback submission failed.");
    //         console.error("Submission error:", err);
    //       }, 2000);
    // }

    try {
      const trimmed = message.trim();

      if (trimmed.length > 0 && !/^[A-Za-z0-9\s.,!?'"()\-@:\/]+$/.test(trimmed)) {
        setAlertType("error");
        setAlertMessage("Message format not supported. Use letters and numbers only.");
        setTimeout(() => setAlertMessage(""), 2000);
        return;
      }

      const response = await FeedbackAPI.submitFeedback(formData);
      const data = response.data;

      if (data.message === "Feedback submitted successfully") {
        setShowSuccessPopup(true);
        setAlertType("success");
        setSubmitted(true);
        // setAlertMessage('Feedback submitted successfully!');

        setTimeout(() => {
          setAlertMessage('');
          window.location.reload();
           setShowSuccessPopup(true);
           setAlertType("success");
           setSubmitted(true);
        }, 2000);

      } else {
        setAlertType("error");
        setAlertMessage(data.message || "Submission failed.");

        setTimeout(() => {
          setAlertMessage('');
        }, 2000);
      }

    } catch (err) {
      setAlertType("error");
      setAlertMessage(err.message || "An unexpected error occurred.");
      console.error("Submission error:", err);

      setTimeout(() => {
        setAlertMessage('');
      }, 2000);
    }
  }

  const renderStarRating = (value, setValue) => (
    <div className="star-rating">
      {[...Array(5)].map((_, idx) => (
        <span
          key={idx}
          onClick={() => {
            const newRating = idx + 1;
            setValue(prev => (prev === newRating ? 0 : newRating));
          }}
          style={{ color: idx < value ? starMap[idx].color : '#ccc', cursor: 'pointer' }}
        >
          <StarIcon />
        </span>
      ))}
      <span style={{ marginLeft: '0.75rem', fontSize: '1rem', color: '#333' }}>
        {value > 0 ? `${value} / 5` : ''}
      </span>
    </div>
  );


  const renderOverallStars = (avg) => {
    const fullStars = Math.floor(avg);
    const hasHalfStar = avg % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <div className="star-rating overall-stars">
        {[...Array(fullStars)].map((_, i) => (
          <StarIcon key={`full-${i}`} style={{ color: starMap[Math.floor(avg) - 1]?.color || '#ccc' }} />
        ))}
        {hasHalfStar && (
          <StarHalfIcon style={{ color: starMap[Math.ceil(avg) - 1]?.color || '#ccc' }} />
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <StarBorderIcon key={`empty-${i}`} style={{ color: '#ccc' }} />
        ))}
      </div>
    );
   };

  // function validateMessage(message) {
  //   if (typeof message !== 'string') {
  //     throw new Error('Message must be a string.');
  //   }
  //   const trimmed = message.trim();
  //   if (trimmed.length > 300) {
  //     throw new Error('Message cannot exceed 300 characters.');
  //   }
  //   if (/^[A-Za-z0-9\s.,!?'"()\-@:\/]+$/.test(trimmed)) {
  //     throw new Error('Message format not supported. Use letters and numbers');
  //   }
  // }


  // Submit button visible
  const canSubmit =
    question1Rating > 0 &&
    question2Rating > 0 &&
    question3Rating > 0 &&
    question4Rating > 0;

  return (
    <>
      <div className="feedback-page">
        {showSuccessPopup && (
          <div className="popup-message">
            Thank you! Your feedback was submitted successfully.
          </div>
        )}
        {alertMessage && (
          <div style={{ marginBottom: '1rem' }}>
            <Alert severity={alertType}>{alertMessage}</Alert>
          </div>
        )}

        <div className="feedback-header">
          <h2>Feedback</h2>
          <span className="form-close-icon" onClick={() => navigate("/")}>
            <CloseRoundedIcon fontSize="small" />
          </span>
        </div>

        {!submitted && (
          <form onSubmit={handleSubmit} className="feedback-form">
            <div className="overall-section">
              <label className="overall-label">Overall Experience</label>
              {renderOverallStars(rating)}
              {rating > 0 && (
                <p className="rating-label">
                  {starMap[Math.round(rating) - 1]?.label || ' '} ({rating.toFixed(1)} / 5)
                </p>
              )}
            </div>
            <table className="rating-table">
              <tbody>
                <tr>
                  <td><label>Login Journey</label></td>
                  <td>{renderStarRating(question1Rating, setQuestion1Rating)}</td>
                </tr>
                <tr>
                  <td><label>Invoice Draft and Submission Journey</label></td>
                  <td>{renderStarRating(question2Rating, setQuestion2Rating)}</td>
                </tr>
                <tr>
                  <td><label>Invoice Dashboard and Search Functionality</label></td>
                  <td>{renderStarRating(question3Rating, setQuestion3Rating)}</td>
                </tr>
                <tr>
                  <td><label>Navigation & Ease Of Use</label></td>
                  <td>{renderStarRating(question4Rating, setQuestion4Rating)}</td>
                </tr>
              </tbody>
            </table>
            <div>
              <label htmlFor="feedback">Any other feedback </label>
              <textarea
                name="feedback"
                placeholder="Provide a detailed feedback"
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                maxLength={300}
                className="form-textarea"
              />
              <small className="helper-text">
                {message.length}/300 characters
              </small>
            </div>

            <button type="submit">Submit</button>
          </form>
        )}
      </div>
    </>
  );
};

export default FeedbackForm;
